export const DESKTOP_DRAWER_WIDTH = 450;
export const MOBILE_DRAWER_MAX_HEIGHT = '90vh';
export const MOBILE_POWERED_BY_HEIGHT = 29;
export const MOBILE_TAB_BAR_HEIGHT = 65;
export const MOBILE_TABS_HEIGHT = MOBILE_TAB_BAR_HEIGHT + MOBILE_POWERED_BY_HEIGHT;

// TProject properties that always use and save database data instead of draft
export const notInDraftProjectProps = {
  // ProjectName screen
  title: true,
  // Address screen
  address: true,
  lat: true,
  lng: true,
  // ProjectConstructors screen
  clients: true,
} as const;

// Type helper for better type safety
export type NotInDraftProjectProps = typeof notInDraftProjectProps;
